import React from "react";
import ChangePassSection from "./../components/ChangePassSection";

function ChangepassPage(props) {
  return (
    <ChangePassSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Choose a new password"
      subtitle=""
      buttonText="Change password"
      inputSize="lg"
    ></ChangePassSection>
  );
}

export default ChangepassPage;
